// extracted by mini-css-extract-plugin
export default {"h1":"ExpertPage_h1__VL6IM","h1Color":"ExpertPage_h1Color__4CRMR","h1Bold":"ExpertPage_h1Bold__meclv","hr":"ExpertPage_hr__cbyJJ","img":"ExpertPage_img__sn06Y"};